import React from "react";

import { Chip, Fade, Grid, Typography } from "@material-ui/core";

import TransactionsTable from "./TransactionsTable";
import { get_transactions } from "../../../api/publisher_transactions_api";
import { SearchTextField } from "../../../components/TextField";
import CustomPagination from "../../../components/CustomPagination";
import { findOrdersHistory } from "../../../redux/Orders/OrderActionCreators";
import Store from "../../../redux/Store";
import { connect } from "react-redux";

const Transactions = ({ historyReducer }) => {
  const [data, set_data] = React.useState([]);
  const [transactions, set_transactions] = React.useState([]);
  React.useEffect(() => {
    get_transactions().then((res) => {
      if (!res) return;
      Store.dispatch(findOrdersHistory(res));
      set_data(res);
    });
  }, []);

  React.useEffect(() => {
    set_transactions(
      data.filter(
        (item) =>
          item.descr.includes(historyReducer.search.toString()) ||
          item?.order_number?.includes(historyReducer.search.toString())
      )
    );
  }, [historyReducer.search, data]);
  // console.log(data);
  return (
    <Fade in>
      <Grid container justifyContent="center" style={{ height: "100%" }}>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          style={{
            backgroundColor: "white",
            boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
            borderRadius: 6,
            height: "100%",
          }}
        >
          <Grid item container>
            <Typography variant="body1">تراکنش ها</Typography>
            <Chip
              label={data.length}
              color="primary"
              style={{ minWidth: 50, fontSize: "15px", marginRight: 16 }}
              size="small"
              variant="outlined"
            />
          </Grid>

          <Grid
            item
            md={12}
            style={{
              height: "80%",
              border: "1px solid rgb(232,232,239)",
              margin: "0px 8px",
            }}
          >
            <Grid item sm={9} xs={7} style={{ height: 35 }}>
              <SearchTextField />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ height: "calc(100% - 53px)", marginTop: 16 }}
            >
              <TransactionsTable data={transactions} />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomPagination />
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};
const mapToStateProps = (props) => {
  const { OrderReducer, historyReducer } = props;
  const { modal_loading } = OrderReducer;

  return { modal_loading, historyReducer };
};

export default connect(mapToStateProps)(Transactions);
